module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "ProductClassifySearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductClassifySearchView!./src/pages/Shop/Product/ProductClassifySearch/indexView.js
// module id = 1770
// module chunks = 367